import React from 'react'
import { Formik, FormikHelpers } from 'formik'
import { View } from 'react-native'
import * as yup from 'yup'

import tw from 'tailwind-rn'
import styles from './styles'
import { HGTextInput } from '../Form'
import { HGButton, HGText } from '../HGUI'

const validationSchema = yup.object({
  username: yup
    .string()
    .email('Bitte gib eine gültige E-Mail-Adresse an.')
    .required('Bitte gib eine gültige E-Mail-Adresse an.'),
})

export type ForgotPaswordValues = {
  username: string
}

const initialValues: ForgotPaswordValues = {
  username: '',
}

type Props = {
  onSubmit: (
    values: ForgotPaswordValues,
    setSubmitting: (value: boolean) => void
  ) => void
  onAbort: () => void
}

const ForgotPasswordForm = (props: Props) => {
  const { onSubmit, onAbort } = props

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(
        values: ForgotPaswordValues,
        { setSubmitting }: FormikHelpers<ForgotPaswordValues>
      ) => {
        // console.log(values)
        onSubmit(values, setSubmitting)
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        values,
        errors,
      }) => (
        <View>
          <View>
            <HGTextInput
              onChangeText={handleChange('username')}
              onBlur={handleBlur('username')}
              value={values.username}
              autoCapitalize="none"
              placeholder="E-Mail-Adresse …"
              keyboardType="email-address"
              textContentType="emailAddress"
              autoCorrect={false}
            />

            {errors.username && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.username}
              </HGText>
            )}
          </View>

          <View style={[styles.actionBox, tw('mt-6')]}>
            <HGButton
              disabled={isSubmitting || !isValid}
              title={
                !isSubmitting ? 'Passwort zurücksetzen' : 'Wird angemeldet …'
              }
              onPress={handleSubmit}
              style={tw('mb-4')}
            />

            <HGButton title="Abbrechen" type="inverted" onPress={onAbort} />
          </View>
        </View>
      )}
    </Formik>
  )
}

export default ForgotPasswordForm
